import { render, staticRenderFns } from "./ProjectsTableWrapper.vue?vue&type=template&id=38162056&scoped=true"
import script from "./ProjectsTableWrapper.vue?vue&type=script&lang=ts"
export * from "./ProjectsTableWrapper.vue?vue&type=script&lang=ts"
import style0 from "./ProjectsTableWrapper.vue?vue&type=style&index=0&id=38162056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38162056",
  null
  
)

export default component.exports